import { makeAutoObservable } from 'mobx';
import {SystemInfoStoreInterface, SystemUserInfoInterface} from "../../interface";
import {DEFAULT_BUSINESS_ID} from "utils/constants";

const defaultSystemInfoStoreDate: SystemInfoStoreInterface = {
    userInfo: {
        name: '',
        group: '',
        businessId: DEFAULT_BUSINESS_ID,
    },
}
class Store {
    userInfo: SystemUserInfoInterface;

    constructor(SystemInfoStore: SystemInfoStoreInterface) {
        makeAutoObservable(
            this,
            {

            },
            {
                autoBind:true
            }
        );
        this.userInfo = SystemInfoStore.userInfo
    }

}

const SystemInfoStore = new Store(defaultSystemInfoStoreDate);

export default SystemInfoStore;